<template>
    <Modal title="Add to Existing Parent" ref="modalRef" width-override="600px">
        <template v-slot:body>
            <div class="margin-b-1">
                Add the following {{ props.companies.length }} divisions to an existing parent company:
                <ul class="company-list">
                    <li v-for="company of props.companies" :key="company.id">
                        <div class="company-list-item">
                            <span>{{ company.name }}</span>
                            <span v-if="settingsStore.debugMode">&nbsp;({{ company.id }})</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="margin-b-2">Parent company:</div>
            <ModelListSelect v-model="selectedGroup" :list="groups" optionText="name" optionValue="id" class="space-hack"/>
        </template>
        <template v-slot:footer>
            <input class="cancel-button button button-secondary" type="button" value="Cancel" @click="cancel()" />
            <input type="button" value="Save" class="button" @click="save()" />
        </template>
    </Modal>
</template>

<script setup>
    import { ref, defineProps, defineEmits, inject, onMounted } from 'vue';
    import { Modal as ModalLib, promptModal } from 'jenesius-vue-modal';
    import { ModelListSelect } from 'vue-search-select';
    import 'vue-search-select/dist/VueSearchSelect.css';
    import { useSettingsStore } from '@/stores/SettingsStore';
    import Modal from './Modal.vue';
    import Alert from '@/components/Alert.vue';
    import Error from '@/components/Error.vue';

    const props = defineProps({
        companies: {
            type: Array,
            required: true
        } 
    });

    const emit = defineEmits([ModalLib.EVENT_PROMPT]);

    const api = inject('api');
    const selectedGroup = ref();
    const groups = ref([]);
    const settingsStore = useSettingsStore();
    const modalRef = ref();

    onMounted(async () => {
        try {
            const justGroups = await api.getJustGroups();
            groups.value = justGroups.data;
        }
        catch (err) {
            promptModal(Error, { message: 'Error retrieving parent data', details: err.stack });
        }
    });

    async function save() {
        if (props.companies.length > 0) {
            if (selectedGroup.value) {
                modalRef.value.showActivityIndicator = true;
                
                try {
                    await api.addCompaniesToGroup(selectedGroup.value, props.companies.map(c => c.id));
                    emit(ModalLib.EVENT_PROMPT, true);
                }
                catch (err) {
                    promptModal(Error, { message: 'Error adding divisions to parent', details: err.stack });
                }
                finally {
                    modalRef.value.showActivityIndicator = false;
                }
            }
            else {
                promptModal(Alert, { title: 'Error', text: 'Please selecte a parent company.' });
            }
        }
        else {
            promptModal(Alert, { title: 'Error', text: 'No companies have been selected to add to this parent. Please try again.' });
        }
    }

    function cancel() {
        emit(ModalLib.EVENT_PROMPT, false);
    }
</script>

<style scoped>
    .footer .button {
        margin-left: 10px;
    }

    .space-hack {
        margin-bottom: 250px;
    }
</style>
